// Vuex project module main file

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  currentList: {
    records: [],
    total: 0,
  },
  list: {
    records: [],
    total: 0,
  },
  filtering_criteria: {},
};

const getters = {
  currentList: state => state.currentList,
  list: state => state.list,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
